module.exports = __webpack_public_path__ + "img/icon_close_2.992c838e.png";